/**
 * specifies whether or not this is a development build.
 */
declare const __DEV__: boolean;

import { registerElements } from "genesys-spark-components";
import "genesys-spark-components/dist/genesys-webcomponents/genesys-webcomponents.css";
// import "util/configureKnockout";
// import ko from "knockout";
import Bluebird from "bluebird";
import Globalize from "globalize";
import moment from "moment-timezone";
import $ from "jquery";
import embeddingService from "services/embeddingService";
import { setPcAuthToken } from "util/pcAuthToken";
import authService from "services/authService";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "app/store";
import { HashRouter } from "react-router-dom";
import React from "react";
import { AppLocaleProvider } from "features/i18n/useLocale";
import { App } from "app/App";

registerElements();
// TODO: link Urbanist and Noto Sans in the stylesheet to improve loading performance

if (__DEV__) {
    import("devTools");
}

// Expose common libraries to the dev console
Object.assign(window, {
    Bluebird,
    // ko,
    Globalize,
    $,
    jQuery: $,
    moment,
});

setPcAuthToken();
authService.init();

const root = createRoot(document.getElementById("root")!);
root.render(
    <React.StrictMode>
        <HashRouter>
            <Provider store={store}>
                <AppLocaleProvider>
                    <App />
                </AppLocaleProvider>
            </Provider>
        </HashRouter>
    </React.StrictMode>
);
embeddingService.notifyInitialized();
